import { CurrencyPipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  annualCost,
  fixedDigits,
  getPercentFrom,
} from '../horizontal-bar-graph.constants';
import { getChartWidth } from '../horizontal-bar-graph.helper';
import {
  BarGraphConfig,
  BarGraphData,
  defaultGraphConfig,
  defaultGroupGraphConfig,
  GraphTypes,
  MobileGraphData,
} from './bar-graph.model';
import { BarChartService } from './bar-graph.service';

@Component({
  selector: 'bar-graph',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './bar-graph.component.html',
  styleUrls: ['./bar-graph.component.scss'],
})
export class BarGraphComponent implements OnChanges, AfterViewInit {
  @ViewChild('chart', { static: true }) chartContainer: ElementRef;
  barGraphData: BarGraphData[];
  mobileGroupedBarData: MobileGraphData[];
  graphConfig: BarGraphConfig;
  colorSchemeIndex = -1;
  minValue = 0;
  maxValue: number;

  constructor(private currencyPipe: CurrencyPipe) {}

  @Input() set data(data: BarGraphData[]) {
    this.maxValue = Math.max.apply(
      Math,
      data.map((graphBarData: BarGraphData) => {
        const chartWidth = getChartWidth(graphBarData, this.graphConfig);

        return chartWidth;
      }),
    );

    data.map((graphBarData: BarGraphData) => {
      this.colorSchemeIndex =
        this.colorSchemeIndex === this.config.colorScheme.length - 1
          ? 0
          : this.colorSchemeIndex + 1;
      graphBarData.color = this.config.colorScheme[this.colorSchemeIndex];
      graphBarData.percentage = Number(
        ((graphBarData.value / this.maxValue) * getPercentFrom).toFixed(
          fixedDigits,
        ),
      );

      return graphBarData;
    });

    const groups = new Set(data.map((item) => item.group));
    const results = [];

    groups.forEach((groupName: string) =>
      results.push({
        name: groupName ? `${groupName} ${annualCost}` : null,
        values: data.filter((i) => i.group === groupName),
      }),
    );
    this.mobileGroupedBarData = results;

    this.barGraphData = data;
  }

  @Input() set config(config: BarGraphConfig) {
    this.graphConfig = config;
  }

  get data(): BarGraphData[] {
    return this.barGraphData;
  }
  get config(): BarGraphConfig {
    return this.graphConfig;
  }

  @HostListener('window:resize')
  onResize() {
    this.createGraph();
  }

  ngOnChanges() {
    this.createGraph();
  }

  ngAfterViewInit() {
    this.createGraph();
  }

  createGraph(): void {
    const element = this.chartContainer.nativeElement;
    const config =
      this.config.type === GraphTypes.standard
        ? { ...defaultGraphConfig, ...this.config }
        : { ...defaultGroupGraphConfig, ...this.config };

    if (element && this.data && this.config) {
      const barChartService = new BarChartService(
        this.chartContainer,
        config,
        this.data,
        this.currencyPipe,
      );

      barChartService.createBarGraph();
    }
  }
}
